import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Types} from "components";

import {Alert, Button} from "reactstrap";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import PropTypes from "prop-types";
import ObjectOverride from "components/ObjectOverride";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";
import Access from "../../constants/Access";
import UniversalModalOverride from "../UniversalModalOverride";
import moment from "moment";

/**
 *  @property {Transactions_Nics_Object} state
 *  @property {object} model
 *  @property {Transactions_Nics_Properties} model.properties
 *  @property {Transactions_Nics_Is} model.is
 *  @property {Transactions_Nics_Has} model.has
 */
class DispositionNics extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		nics: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props, Types.Transactions_Nics._name);
	}

	// noinspection JSUnusedGlobalSymbols
	loadSelf = async () => {
		let data = this.props.nics;
		if (this._ismounted) {
			this.model.properties.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			this.model.has.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			this.model.is.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			await this.setState({
				"loading": false,
				"loaded": true
			});
			// noinspection JSPotentiallyInvalidUsageOfClassThis
			this.loadSelfAfter(data);
		}

		this.loadSelfAfterAlways();
	};

	redirectToNics = () => {
		// this.props.history.push('/dispositions/enics_statuses');
		window.open('https://www.cjis.gov/', '_blank')
	}

	// componentDidUpdate(prevProps, prevState, snapshot) {
	// 	super.componentDidUpdate(prevProps, prevState, snapshot);
	// 	if(this.state.overturned !== prevState.overturned && !this.state.overturned_date && this.state.overturned === true) {
	// 		this.toggle('modalOverturned')();
	// 	}
	// }

	handleToggleSigModal = () => {
		super.handleSubmit(this, false);
		this.toggle('modalOverturned')();
	}

	updateOverturn = (signature_30, signature_30_date) => {
		this.state.signature_30 = signature_30;
		this.state.signature_30_date = signature_30_date;
		this.props.overturnFunction(signature_30, signature_30_date);
		this.handleSubmit(null, false);
		// ToDo: Need to refresh page here somehow
	}

	handleAfterSave = (data) => {
		super.handleAfterSave(data);
	}

	handleDeletePermit = () => {
		confirmAlert({
			title: 'Confirm Delete',
			message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to Remove this Permit?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							let pModel = new API.BuildClass(Types.Customers_Permits._name, API.RequestType.DELETE);
							pModel.object.pkey = this.props.id;
							pModel.parent = this.props.customer;
							pModel.parent_binary_id = this.props.customerBinaryID;
							await pModel.submit(null, API.RequestType.DELETE);
							this.state.permit_type = '';
							this.state.permit_date = '';
							this.state.permit_expiration = '';
							this.state.permit_number = '';
							this.forceUpdate();
						} catch (error) {
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}


	form = () => {
		/** @type {Transactions_Nics_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Nics_Object} object */
		let object = this.state;
		let {rootState} = this.props;
		let {userAccess} = rootState;
		return (
			<fieldset>
				{/*#region NICS Logic*/}

				{/*region NICS Exception*/}

				<h4 className="section-title">NICS Exception{(object.permit_type || object.permit_number) &&
					<Button style={{float: 'right'}} color="danger" onClick={this.handleDeletePermit}>Remove Permit</Button>}</h4>
				<div className={'form-group'}>
					<div className={'row'}>
						<div className={'col-6'}>
							<span className={'input-label'}>N.F.A firearm(s)</span>
						</div>
						<div className={'col-6 text-right'}>
							<Framework.Elements.ButtonSwitch
								property={properties.national_fire_arms_act}
								value={object.national_fire_arms_act}
								error={object.national_fire_arms_act_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
				</div>
				<div className={'form-group'}>
					<div className={'row'}>
						<div className={'col-6'}>
							<span className={'input-label'}>or Valid Permit</span>
						</div>
						<div className={'col-6 text-right'}>
							<Framework.Elements.ButtonSwitch
								property={properties.valid_permit}
								value={object.valid_permit}
								error={object.valid_permit_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
				</div>
				{/*endregion*/}

				{/*region (Valid Permit TRUE)*/}

				{/*if true display these for valid_permit*/}
				{object.valid_permit === true ?
					<div>
						<div className={'form-group'}>
							<Framework.Elements.Select
								shouldLoad={this.state.loaded}
								update={this.handleSelectPropertyUpdate}
								property={properties.permit_state}
								value={object.permit_state}
								error={object.permit_state_error}

								model={Types.States._name}
								id={'short'}
								nullable={false}
								limit={null}
							/>
						</div>
						<div className={'form-group'}>
							<Framework.Elements.TextField
								property={properties.permit_type}
								value={object.permit_type}
								error={object.permit_type_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={'form-group'}>
							<Framework.Elements.Date
								property={properties.permit_date}
								value={object.permit_date}
								error={object.permit_date_error}
								label={"Permit Issued Date"}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={'form-group'}>
							{/*TODO: #masonAsk*/}
							<Framework.Elements.Date
								property={properties.permit_expiration}
								value={object.permit_expiration}
								error={object.permit_expiration_error}
								label={"Permit Expiration Date"}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={'form-group'}>
							<Framework.Elements.TextField
								property={properties.permit_number}
								value={object.permit_number}
								error={object.permit_number_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div> : null
				}

				{/*endregion*/}

				{/*region NFA FALSE && Valid Permit FALSE*/}

				{/*//display these if the nfa firearms is false and valid_permit is false*/}
				{!object.national_fire_arms_act && !object.valid_permit &&
					<div>

						{/*region LEEP Background Check*/}

						<div className={'form-group'}>
							<h4 className="section-title">LEEP Background Check</h4>
						</div>
						<div className={'form-group'}>
							<p style={{fontSize: '11px'}}>
								Once you complete the background check you can check the results from LEEP.
							</p>
						</div>
						<div className={'form-group'}>
							<Button color={'primary'} onClick={this.redirectToNics}>Access LEEP</Button>
						</div>
						<div className={'form-group'}>
							<p style={{fontSize: '11px'}}>
								Click <a href={'https://www.cjis.gov'} target={'_blank'}>here </a>to setup a LEEP account for
								online background checks.
							</p>
						</div>

						{/*endregion*/}

						{/*region NICS (or State POC)*/}

						<h4 className="section-title">NICS (or State POC)</h4>
						<div className={'form-group'}>
							<p style={{fontSize: '11px'}}>
								Date the transferee’s/buyer’s identifying information in Section B was transmitted to NICS or the appropriate State
								agency:
							</p>
						</div>
						<div className={"row"}>
							<div className={"col-sm"}>
								<div className="form-group">
									<Framework.Elements.Date
										property={properties.nics_date}
										value={object.nics_date}
										error={object.nics_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>
							<div className={"col-sm"}>
								<div className="form-group">
									<Framework.Elements.TextField
										label={'Number'}
										property={properties.nics_number}
										value={object.nics_number}
										error={object.nics_number_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>
						<div className={'form-group'}>

							<Framework.Elements.Select
								shouldLoad={true}
								update={this.handleSelectPropertyUpdate}
								property={properties.nics_response}
								value={object.nics_response}
								error={object.nics_response_error}
								disabled={this.props.isCancelled}
								model={Types.Nics_Responses._name}
								id={'name'}
								label={"NICS Response"}
								nullable={true}
								limit={null}
							/>

						</div>

						{/*endregion*/}

						{/*region nics_response === 'Delayed'*/}
						{/*region The firearm(s) may be transferred on*/}

						<h4 className="section-title">The firearm(s) may be transferred on</h4>
						<div className={'form-group'}>
							<p style={{fontSize: '11px'}}>
								The firearm(s) may be transferred on <strong>the below date</strong> if State law permits
								(optional)
							</p>
						</div>
						<div className="form-group">
							<Framework.Elements.Date
								property={properties.mdi_date}
								value={object.mdi_date}
								error={object.mdi_date_error}
								update={this.handleTextFieldPropertyUpdate}
								appendTime={true}
							/>
						</div>
						{/*endregion*/}
					</div>
				}


				{/*endregion*/}

						{/*region Delayed Response*/}

						<h4 className="section-title">NICS Following Responses - 27 D</h4>

						<div className={'form-group'}>
							<p style={{fontSize: '11px'}}>
								Prior to transfer the following response(s) was/were later provided by NICS or the appropriate State
								agency:
							</p>
						</div>
						<div className={"row"}>
							<div className={"col-6"}>
								<div className="form-group" style={{marginTop: -5}}>
									<Framework.Elements.Checkbox
										value={object.following_proceed !== null && object.following_proceed !== '' ? object.following_proceed : (object.delayed_response !== null && object.delayed_response === "Proceed")}
										property={properties.following_proceed}
										error={object.following_proceed_error}
										update={() => (this.setState({following_proceed: !this.state.following_proceed}))}
										color="primary"
										label={'Proceed'}
									/>
								</div>
							</div>
							<div className={"col-6"}>
								<div className="form-group">
									<Framework.Elements.Date
										label={"Proceed Date"}
										property={properties.following_proceed_date}
										value={object.following_proceed_date !== null ? object.following_proceed_date : (object.delayed_response !== null && object.delayed_response === "Proceed") ? object.delayed_date : null}
										error={object.following_proceed_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>
						</div>
						<div className={"row"}>
							<div className={"col-6"}>
								<div className="form-group" style={{marginTop: -5}}>
									<Framework.Elements.Checkbox
										value={object.following_denied !== null && object.following_denied !== '' ? object.following_denied : (object.delayed_response !== null && object.delayed_response === "Denied")}
										property={properties.following_denied}
										error={object.following_denied_error}
										update={() => (this.setState({following_denied: !this.state.following_denied}))}
										color="primary"
										label={'Denied'}
									/>
								</div>
							</div>
							<div className={"col-6"}>
								<div className="form-group">
									<Framework.Elements.Date
										label={"Denied Date"}
										property={properties.following_denied_date}
										value={object.following_denied_date !== null ? object.following_denied_date : (object.delayed_response !== null && object.delayed_response === "Denied") ? object.delayed_date : null}
										error={object.following_denied_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>
						</div>
						<div className={"row"}>
							<div className={"col-6"}>
								<div className="form-group" style={{marginTop: -5}}>
									<Framework.Elements.Checkbox
										value={object.following_cancelled !== null && object.following_cancelled !== '' ? object.following_cancelled : (object.delayed_response !== null && object.delayed_response === "Cancelled")}
										property={properties.following_cancelled}
										error={object.following_cancelled_error}
										update={() => (this.setState({following_cancelled: !this.state.following_cancelled}))}
										color="primary"
										label={'Cancelled'}
									/>
								</div>
							</div>
							<div className={"col-6"}>
								<div className="form-group">
									<Framework.Elements.Date
										label={"Cancelled Date"}
										property={properties.following_cancelled_date}
										value={object.following_cancelled_date !== null ? object.following_cancelled_date : (object.delayed_response !== null && object.delayed_response === "Cancelled") ? object.delayed_date : null}
										error={object.following_cancelled_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>
						</div>
						<div className={"row"}>
							<div className={"col-6"}>
								<div className="form-group" style={{marginTop: -5}}>
									<Framework.Elements.Checkbox
										value={object.overturned !== null && object.overturned !== '' ? object.overturned : false}
										property={properties.overturned}
										error={object.overturned_error}
										update={() => (this.setState({overturned: !this.state.overturned}))}
										color="primary"
										label={'Overturned'}
									/>
								</div>
							</div>
							<div className={"col-6"}>
								<div className="form-group">
									<Framework.Elements.Date
										label={"Overturned Date"}
										property={properties.overturned_date}
										value={object.overturned_date}
										error={object.overturned_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>
						</div>
						<div className={"row"}>
							<div className={"col-12"}>
								<div className="form-group" style={{marginTop: -5}}>
									<Framework.Elements.Checkbox
										value={object.no_response !== null && object.no_response !== '' ? object.no_response : (object.delayed_response !== null && object.delayed_response === "No resolution within 3 business days")}
										property={properties.no_response}
										error={object.no_response_error}
										update={() => (this.setState({no_response: !this.state.no_response}))}
										color="primary"
										label={'No response within 3 business days'}
									/>
								</div>
							</div>
						</div>
						<div className={"row"}>
							<div className={"col-12"}>
								<div className="form-group" style={{marginTop: -5}}>
									<Framework.Elements.Checkbox
										value={object.delayed_response !== null && object.delayed_response !== '' && (object.delayed_response === true || object.delayed_response === "1") ? object.delayed_response : false}
										property={properties.delayed_response}
										error={object.delayed_response_error}
										update={() => (this.setState({delayed_response: !this.state.delayed_response}))}
										color="primary"
										label={'Under 21 - Additional Delay'}
									/>
								</div>
							</div>
							<div className={"col-6"}>
								<div className="form-group">
									<Framework.Elements.Date
										label={"Received On Date"}
										property={properties.delayed_under_21_date}
										value={object.delayed_under_21_date}
										error={object.delayed_under_21_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>
							<div className={"col-6"}>
								<div className="form-group">
									<Framework.Elements.Date
										label={"May Transfer On Date"}
										property={properties.delayed_date}
										value={(object.delayed_response === true || object.delayed_response === "1") ? object.delayed_date : null}
										error={object.delayed_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>
						</div>
						<div className={"row"}>
							<div className={"col-12"}>
								<div className="form-group" style={{marginTop: -5}}>
									<Framework.Elements.Checkbox
										value={object.following_under_21_no_response !== null && object.following_under_21_no_response !== '' ? object.following_under_21_no_response : false}
										property={properties.following_under_21_no_response}
										error={object.following_under_21_no_response_error}
										update={() => (this.setState({following_under_21_no_response: !this.state.following_under_21_no_response}))}
										color="primary"
										label={'Under 21 - No response within 10 days after delay'}
									/>
								</div>
							</div>
						</div>
						<h4 className="section-title">After Transfer Response - 27 E</h4>
						<div className={'form-group'}>
							<p style={{fontSize: '11px'}}>
								<i>(Complete if applicable.)</i> After the firearm was transferred, the following response
								was
								received from NICS or the appropriate State agency on:
							</p>
						</div>
						<div className={"row"}>
							<div className={"col-sm"}>
								<div className="form-group">
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										property={properties.after_response}
										value={object.after_response}
										error={object.after_response_error}
										model={Types.Nics_After._name}
										id={'name'}
										label={"NICS After Transfer Response"}
										nullable={true}
										limit={null}
										disabled={this.props.isCancelled}
									/>
								</div>
							</div>
							<div className={"col-sm"}>
								<div className="form-group">
									<Framework.Elements.Date
										property={properties.after_response_date}
										value={object.after_response_date}
										error={object.after_response_date_error}
										update={this.handleTextFieldPropertyUpdate}
										appendTime={true}
									/>
								</div>
							</div>

						</div>
				<div>
					{this.state.overturned === true && this.props.showSig30 &&
						<Alert color="info" style={{border: '1px solid #dca7b0', padding: '15px'}}>
							<p style={{fontSize: '14px', textAlign: 'center', marginBottom: '0'}}>
								<b style={{fontSize: '16px'}}>Line 30 requires a signature for overturned by the customer upon transaction complete</b>
								<br/>
								<Button color="green-meadow" size={"sm"} block={false}
								        onClick={this.handleToggleSigModal}>
									Sign Line 30
								</Button>
							</p>
						</Alert>}
				</div>



				{/*</div>}*/}
				<UniversalModalOverride
					title="Signature 30 Nics Overturned"
					// submitLabel="Start Inventory"
					locations={this.props.locations}
					// id={this.state.collection_binary_id + this.state.collection}
					states={this.props.states}
					name="Nics Overturned"
					object={Objects.Signature30Form}
					history={this.props.history}
					toggle={this.state['modalOverturned']}
					reportClose={this.reportClose('modalOverturned')}
					afterSave={this.handleAfterSave}
					objectProps={{
						dispoId: this.state.collection_binary_id + '-' + this.state.collection,
						updateFunction: this.updateOverturn
					}}
				/>
				{/*endregion*/}

				{/*endregion*/}
			</fieldset>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions>
					<Button color="danger" onClick={this.handleDelete}>Delete</Button>
					<Button color="primary" onClick={this.handleSubmit}>Save</Button>
				</CardActions>
			</Card>
		)
	}

}

export default Framework.Components.withRootState(DispositionNics);
